module.exports = __webpack_public_path__ + "static/media/banner-mobile-title.4a06be9a.svg";